// This file is automatically generated. Do not edit manually.

import { IsoDateTimeString } from "src/types/dateTime";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace MellanoComponentProductionStatusViewApi {
	export async function getOrders(): Promise<
		Array<MellanoComponentProductionStatusViewApi_Order>
	> {
		const response = await makeAxiosRequest({
			url: "/api/ext/mellano/componentProduction/getOrders",
			method: "POST",
			data: {},
		});
		return response as Array<MellanoComponentProductionStatusViewApi_Order>;
	}

	export async function getOrderComponentBatches(args: {
		orderNumber: number;
	}): Promise<Array<MellanoComponentProductionStatusViewApi_ComponentBatchDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/mellano/componentProduction/getOrderComponentBatches",
			method: "POST",
			data: {
				orderNumber: args.orderNumber,
			},
		});
		return response as Array<MellanoComponentProductionStatusViewApi_ComponentBatchDto>;
	}
}

export interface MellanoComponentProductionStatusViewApi_Order {
	completed: boolean;
	componentBatchCount: number;
	orderNum: number;
}

export interface MellanoComponentProductionStatusViewApi_ComponentBatchDto {
	batchCode: string;
	completed: boolean;
	kanbanQuantity: number;
	specialsQuantity: number;
	startDate: IsoDateTimeString | null | undefined;
}
